import * as React from "react";
import classNames from "classnames";
import {
	WithStyles,
	Theme,
	createStyles,
	withStyles,
	ListItemSecondaryAction
} from "@material-ui/core";
import { connect } from "react-redux";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/Button";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import GetAppIcon from "@material-ui/icons/GetApp";

import { Dispatch } from "redux";
import { StoreState } from "../../reducers/root-reducer";
import { Area } from "../../api/areas";
import { Capabilities } from "../../integration/capabilities";

interface State {
	downloadMenuAnchor: HTMLElement;
}

export interface PrintviewListItemProps {
	title: string;
	onEMailClick: () => void;
	onDownloadClick: (area: Area) => void;
	areaSelect?: boolean;
}

interface ConnectedPrintviewListItemProps extends WithStyles<typeof styles> {
	areas: Area[];
	capabilities: Capabilities;
}

type Props = PrintviewListItemProps & ConnectedPrintviewListItemProps;

export class PrintviewListItem extends React.Component<Props, State> {
	public state: State = {
		downloadMenuAnchor: null
	};

	private handleDownloadButtonClick = (
		event: React.MouseEvent<HTMLElement>
	) => {
		this.setState({ downloadMenuAnchor: event.currentTarget });
	};

	private handleDownloadMenuClose = () => {
		this.setState({ downloadMenuAnchor: null });
	};

	public render() {
		const {
			classes,
			onEMailClick,
			onDownloadClick,
			title,
			areas,
			capabilities,
			areaSelect
		} = this.props;
		const { downloadMenuAnchor } = this.state;

		return (
			<ListItem>
				<ListItemText>{title}</ListItemText>
				<ListItemSecondaryAction>
					<IconButton onClick={onEMailClick}>
						<AlternateEmailIcon />
					</IconButton>
					{capabilities.type !== "mobile" && (
						<React.Fragment>
							{areaSelect ? (
								<React.Fragment>
									<IconButton
										onClick={this.handleDownloadButtonClick}
									>
										<GetAppIcon />
									</IconButton>
									<Menu
										anchorEl={downloadMenuAnchor}
										open={Boolean(downloadMenuAnchor)}
										onClick={this.handleDownloadMenuClose}
									>
										<MenuItem onClick={() => onDownloadClick(null)}>
											<strong>Alle</strong>
										</MenuItem>
										{areas.map(area => (
											<MenuItem
												key={area.id}
												onClick={() => onDownloadClick(area)}
											>
												{area.name}
											</MenuItem>
										))}
									</Menu>
								</React.Fragment>
							) : (
								<IconButton onClick={() => onDownloadClick(null)}>
									<GetAppIcon />
								</IconButton>
							)}
						</React.Fragment>
					)}
				</ListItemSecondaryAction>
			</ListItem>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	areas: state.areas,
	capabilities: state.capabilities
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

const styles = (theme: Theme) => createStyles({});

export const ConnectedPrintviewListItem = withStyles(styles)(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(PrintviewListItem)
);
